/* TYPE OF THE PROCESS, ACTUALLY WE HAVE 3 TYPES */
export const ATTENDEES_PDF = "attendees_pdf";
export const PARTICIPATION = "participation";
export const SCAN = "scan";
export const SCAN_FAILED = "scan_failed";
export const SCAN_STATS = "scan_stats";
export const OPERATORS = "operators";
export const CHECKPOINTS = "checkpoints";

/* STATUS IN STRING */
export const EXPORT_STATUS_DONE_STRING = "done";
export const EXPORT_STATUS_PROGRESS_STRING = "in-progress";
export const EXPORT_STATUS_READY_STRING = "ready";
export const EXPORT_STATUS_IN_VALIDATION_STRING = "in-validation";

/* STATUS OF THE EXPORT */
export const EXPORT_STATUS_NONE = 0;
export const EXPORT_STATUS_PROGRESS = 1;
export const EXPORT_STATUS_READY = 2;

/* CONSTANTS FORT THE ACTIONS */
export const ADD_ONE = Symbol("EXPORTS_ADD_ONE");
export const CLEAR_ALL = Symbol("EXPORTS_CLEAR_ALL");
export const CLEAR_ONE = Symbol("EXPORTS_CLEAR_ONE");
export const UPDATE_ONE = Symbol("EXPORTS_UPDATE_ONE");

/* SIDE PART FORT THE PAGES */
export const PAGE_CHECKPOINTS = "checkpoints";
export const PAGE_REPORT = "report";

/**
 * addOne's function to add the new export inside reducer
 * @param {object} data - All required data for the process
 * @param {object} options - Options to set for the reducer
 * @param {string} options.page - Page where the export is situated
 * @return {object} - The action with type property
 */
export const addOne = (data, options) => ({
	type: ADD_ONE,
	data,
	options
});

/**
 * updateOne's function to update the export inside reducer
 * @param {object} data - All required data for the process
 * @param {object} options - Options to set for the reducer
 * @param {string} options.page - Page where the export is situated
 * @return {object} - The action with type property
 */
export const updateOne = (data, options) => ({
	type: UPDATE_ONE,
	data,
	options
});

/**
 * clearAll - Remove all the data inside the reducer
 * @return {object} - The action with type property
 */
export const clearAll = () => ({
	type: CLEAR_ALL
});

/**
 * clearOne - Remove one export inside the reducer
 * @return {object} - The action with type property
 */
export const clearOne = id => ({
	type: CLEAR_ONE,
	id
});
